import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09028194&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=09028194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09028194",
  null
  
)

export default component.exports